import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import tinycolor from 'tinycolor2';

const style = {
    modal: {
        textAlign: 'center',
        paddingBottom: 0
    },
    icon: {
        fontSize: 40,
        verticalAlign: 'middle',
        marginRight: 10
    }
};

const AssetInfo = function (props) {
    let keywords = null;
    if (props.keywords && props.keywords.length) {
        keywords = props.keywords.map((word, index) => {
            return <span key={index}>{word}{index < props.keywords.length - 1 ? ',' : '' } </span>;
        });
    }

    const actions = [
        <FlatButton
            label="Yes"
            primary={true}
            onTouchTap={props.deleteAsset}
        />,
        <FlatButton
            label="No"
            primary={true}
            onTouchTap={props.closeModal}
        />
    ];

    const wtRed = '#db1f2b';
    const wtRedHover = tinycolor(wtRed).lighten(20).toHexString();

    return <div>
        <div className='wt-asset-info'>
            <h3>{props.title}</h3>
            {props.caption && <p>{props.caption}</p>}
            {keywords && <div className="wt-keywords">
                <strong>Keywords: </strong>
                <span>{keywords}</span>
            </div>}
        </div>
        <Dialog actions={actions} actionsContainerClassName="wt-dialog-actions" modal={true} open={props.showModal} bodyStyle={style.modal}>
            Are you sure you want to remove this item?</Dialog>
        <div className="wt-delete-button">
            <FlatButton label="Remove from the gallery" labelStyle={{textTransform: 'none'}} backgroundColor={wtRed} hoverColor={wtRedHover}
                        style={{color: 'white', width: '100%'}} onTouchTap={props.openModal}/>
        </div>
    </div>;

};

export default AssetInfo;